"use strict";
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderLogo = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/header.css");
/**
 * Header Title section
 * @example
 * <HeaderLogo logo={<SvgImodelHollow />}>iTwin Application</HeaderLogo>
 * <HeaderLogo logo={<SvgImodelHollow />} />
 * <HeaderLogo logo={<img src='image.png' />} />
 * <HeaderLogo logo={<img src='data:image/png;base64,...' />}>Downloaded Image</HeaderLogo>
 */
exports.HeaderLogo = React.forwardRef((props, ref) => {
    const { className, children, logo, onClick, as: Element = !!onClick ? 'button' : 'div', ...rest } = props;
    (0, index_js_1.useTheme)();
    return (React.createElement(Element, { className: (0, classnames_1.default)('iui-header-brand', className), onClick: onClick, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- TS complains here but it's ok; it is an implementation detail
        // @ts-ignore
        ref: ref, ...rest },
        React.isValidElement(logo)
            ? React.cloneElement(logo, {
                className: (0, classnames_1.default)('iui-header-brand-icon', logo.props.className),
            })
            : undefined,
        children && React.createElement("span", { className: 'iui-header-brand-label' }, children)));
});
exports.default = exports.HeaderLogo;
